import { createClient } from "@/shared/urql/urql";
import {
  CustomerManagementRegisterInvitedUserDocument,
  CustomerManagementRegisterUserMutationError,
  type CustomerManagementRegistrationDataInput,
} from "@/shared/generated/graphql";
import { handleCombinedError } from "@/shared/helper/handleCombinedError.helper";
import { handleErrors } from "@/shared/helper/handleErrors.helper";

export const registerInvitedUser = async (
  registrationData: CustomerManagementRegistrationDataInput,
) => {
  const urqlClient = createClient();

  const { error, data } = await urqlClient
    .mutation(CustomerManagementRegisterInvitedUserDocument, {
      registrationData,
    })
    .toPromise();
  const errors = data?.customerManagementRegisterInvitedUser.errors;

  if (
    errors?.length === 1 &&
    (errors[0] ===
      CustomerManagementRegisterUserMutationError.MultipleContactsFound ||
      errors[0] === CustomerManagementRegisterUserMutationError.UserDataDiffers)
  ) {
    return {
      caseNumber: data?.customerManagementRegisterInvitedUser.caseNumber,
    };
  }

  if (error) throw handleCombinedError(error);

  if (!errors || errors.length === 0)
    return {
      registrationFinished:
        data?.customerManagementRegisterInvitedUser.registrationFinished,
    };

  throw handleErrors(errors);
};
